var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "insurance_container" },
    _vm._l(13, function(i) {
      return _c("div", { key: i, staticClass: "insurance" }, [
        _c(
          "div",
          {
            staticClass: "bloc-title",
            on: {
              click: function($event) {
                _vm.collapsedOffers[i] = !_vm.collapsedOffers[i]
              }
            }
          },
          [
            _c("p", [
              _vm._v(
                "#" +
                  _vm._s(i) +
                  "   " +
                  _vm._s(_vm.$t("insurance-faq.bloc-title-" + i))
              )
            ]),
            _vm._v(" "),
            _c(
              "a",
              {
                class: [
                  "collapse-button",
                  _vm.isVisible(i) ? "rotate-close" : "rotate-open"
                ]
              },
              [
                _c("i", { staticClass: "material-icons arrow-down-icon" }, [
                  _vm._v("keyboard_arrow_down")
                ])
              ]
            )
          ]
        ),
        _vm._v(" "),
        _c("div", {
          class: [
            _vm.isVisible(i) ? "collapse-open" : "collapse-close",
            "collapsible-details",
            "bloc-description"
          ],
          domProps: {
            innerHTML: _vm._s(
              "<p>" + _vm.$t("insurance-faq.bloc-description-" + i) + "</p>"
            )
          }
        })
      ])
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-37e8ecda", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-37e8ecda","hasScoped":false,"buble":{"objectAssign":"Object.assign","transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/InsuranceFaq.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-37e8ecda","hasScoped":false,"buble":{"objectAssign":"Object.assign","transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/InsuranceFaq.vue
// module chunks = 1 2 3